import { AnyAction } from 'redux';
import { EReduxTypes } from 'ts/enums/redux.types';
import { IReduxAction } from 'ts/interfaces/redux/redux.action';

export const initEventStream = (): AnyAction => {
  const action: IReduxAction = {
    type: EReduxTypes.INIT_EVENT_STREAM,
    event: {
        path: 'events/stream'
    }
  };
  return action;
};
